import { render, staticRenderFns } from "./PopupReason.vue?vue&type=template&id=02f99d52&scoped=true&"
import script from "./PopupReason.vue?vue&type=script&lang=ts&"
export * from "./PopupReason.vue?vue&type=script&lang=ts&"
import style0 from "./PopupReason.vue?vue&type=style&index=0&id=02f99d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f99d52",
  null
  
)

export default component.exports